const checkUrl = (str: string) => {
  const regex = /^(ftp|http|https):\/\/[^ "]+$/;
  return regex.test(str);
};

export default checkUrl;
